<template>
  <div class="host page">
    <DataTable
      title="Государственный реестр лекарственных средств"
      :permissions="['read']"
      :service="service"
      :fields="tableFileds"
      :pageSize="20" 
    />
  </div>
</template>

<script>
import DataTable from '@app/components/uikit/DataTable';
import { dictionaryGrlsApi } from '@app/services';

export default {
  components: {
    DataTable
  },
  data: () => ({
    service: dictionaryGrlsApi,
    tableFileds: [
      {
        name: 'S_TORG_NAME',
        label: 'Торговое название'
      },
      {
        name: 'S_MNN',
        label: 'МНН'
      },
      {
        name: 'S_FORMS',
        label: 'Формы выпуска'
      },
      {
        name: 'S_DOCS',
        label: 'Нормативная документация'
      },
      {
        name: 'S_FARM_GROUP',
        label: 'Фармако-терапевтическая группа'
      },
    ]
  })
};
</script>
